<template>
  <div>
    <van-tabs v-model="active" @click="getData">
      <van-tab title="租房">
        <div>
          <div class="adminhouse">
            <ul>
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                :immediate-check="false"
              >
                <li v-for="(item,index) in lists" :key="index">
                  <div class="litop">
                    <div class="img" @click="$router.push('/zufang/view/'+item.id)">
                      <div class="top" v-if="item.stick"></div>
                      <img :src="item.thumbnail" />
                    </div>
                    <div class="info">
                      <h1 @click="$router.push('/zufang/view/'+item.id)">{{item.title}}</h1>
                      <p class="txt3">刷新时间：{{item.refreshtime_cn}}</p>
                      <p class="txt3">租金：{{item.price}}{{item.unit}}</p>
                      <p class="txt3">小区：{{item.community}}</p>
                    </div>
                  </div>
                  <p class="litopbtn">
                    <van-tag
                      type="warning"
                      size="medium"
                      text-color="#fff"
                      @click="zhifu(item.id,'zufang')"
                    >支付</van-tag>
                  </p>
                </li>
              </van-list>
            </ul>
          </div>
        </div>
      </van-tab>
     <!-- <van-tab title="二手房">
        <div>
          <div class="adminhouse">
            <ul>
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                :immediate-check="false"
              >
                <li v-for="(item,index) in lists" :key="index">
                  <div class="litop">
                    <div class="img" @click="$router.push('/zufang/view/'+item.id)">
                      <div class="top" v-if="item.stick"></div>
                      <img :src="item.thumbnail" />
                    </div>
                    <div class="info">
                      <h1 @click="$router.push('/zufang/view/'+item.id)">{{item.title}}</h1>

                      <p class="txt3">刷新时间：{{item.refreshtime_cn}}</p>
                      <p class="txt3">浏览量：{{item.clicks}}次</p>
                    </div>
                  </div>
                  <p class="litopbtn">
                    <van-tag
                      type="warning"
                      size="medium"
                      text-color="#fff"
                      @click="zhifu(item.id,'ershoufang')"
                    >支付</van-tag>
                  </p>
                </li>
              </van-list>
            </ul>
          </div>
        </div>
      </van-tab> -->
      <van-tab title="商铺">
        <div>
          <div class="adminhouse">
            <ul>
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                :immediate-check="false"
              >
                <li v-for="(item,index) in lists" :key="index">
                  <div class="litop">
                    <div class="img" @click="$router.push('/zufang/view/'+item.id)">
                      <div class="top" v-if="item.stick"></div>
                      <img :src="item.thumbnail" />
                    </div>
                    <div class="info">
                      <h1 @click="$router.push('/zufang/view/'+item.id)">{{item.title}}</h1>

                      <p class="txt3">刷新时间：{{item.refreshtime_cn}}</p>
                      <p class="txt3">浏览量：{{item.clicks}}次</p>
                    </div>
                  </div>
                  <p class="litopbtn">
                    <van-tag
                      type="warning"
                      size="medium"
                      text-color="#fff"
                      @click="zhifu(item.id,'shop')"
                    >支付</van-tag>
                  </p>
                </li>
              </van-list>
            </ul>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <footbar />
  </div>
</template>

<script>
var root = process.env.VUE_APP_API_URL;

import Footbar from "../../commpents/footbar";

import {
  Toast,
  DropdownMenu,
  DropdownItem,
  TreeSelect,
  Tag,
  List,
  Icon,
  Button,
  Dialog,
  Tab,
  Tabs,
  Row,
  Col,
  Search
} from "vant";

export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [TreeSelect.name]: TreeSelect,
    [Tag.name]: Tag,
    [List.name]: List,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Row.name]: Row,
    [Col.name]: Col,
    [Search.name]: Search,

    Footbar
  },

  data() {
    return {
      getInitUrl: root + "user/nopay",
      value: 0,
      type: "zufang",
      page: 1,
      lists: [],
      total: 0,
      loading: false,
      finished: false,
      active: 0
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      var self = this;
      $.ajax({
        url: self.getInitUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: { page: self.page, type: self.type },
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          var lists = reponseData.data.lists;
          if (lists.length == 0) {
            self.finished = true;
          }
          self.loading = false;
          self.total = reponseData.data.total;
          for (var i in lists) {
            self.lists.push(lists[i]);
          }
          self.page++;
        },
        error: function() {
          self.$toast("system error");
        }
      });
    },
    getData(name, title) {
      this.page = 1;
      this.lists = [];
      this.loading = true;
      this.finished = false;

      if (this.active == 0) {
        this.type = "zufang";
      }
      if (this.active == 1) {
        this.type = "ershoufang";
      }
      if (this.active == 2) {
        this.type = "shop";
      }
      this.init();
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        if (this.page >= this.total) {
          this.finished = true;
          this.loading = false;
          return;
        }
        this.loading = true;
        this.init();
      }, 500);
    },
    zhifu(id, type) {
      this.$router.push("/post/zhifu/" + id + "/" + type);
    }
  }
};
</script>

<style scoped>
.user {
  background-color: #3072f6;
  display: flex;
  padding: 30px 25px;
  color: #fff;
}
.avatar-img {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar-img img {
  width: 80%;
}
.avatar-info {
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar-info h1 {
  font-size: 18px;
}
.avatar-info p {
  font-size: 14px;
  color: #fff;
  padding: 4px 0;
}
.user-tag {
  text-align: center;
  padding: 15px 0;
}
.user-tag img {
  width: 40px;
}
.user-tag h1 {
  margin-top: 6px;
  font-size: 14px;
  font-weight: normal;
  color: #555;
}
.user-logout {
  text-align: center;
  padding: 15px;
  margin: 15px;
  background-color: #f8f8f8;
  border-radius: 4px;
}
</style>>



